/** @jsxImportSource @emotion/react */
import { styles } from './ExpandedJob.styles';
import { Job } from '../../api/JobsApi';

function TextSection({ title, text }: { title: string; text?: string }) {
  if (!text) return null;

  return (
    <div css={styles.section}>
      <h4>{title}</h4>
      <p css={styles.preserveText}>{text}</p>
    </div>
  );
}

function Section({ title, text }: { title: string; text?: string }) {
  if (!text) return null;

  const items = text
    .split('\n')
    .map(line => line.replace(/^[-•]\s*/, '').trim())
    .filter(Boolean);

  return (
    <div css={styles.section}>
      <h4>{title}</h4>

      {items.length > 1 ? (
        <ul>
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      ) : (
        <p>{text}</p>
      )}
    </div>
  );
}

export default function ExpandedJob({ job }: { job: Job }) {
  const title = job.title || 'Untitled position';
  const location = job.location?.name || 'Location not specified';
  const skills = Array.isArray(job.skills) ? job.skills : [];

  const mailto = `mailto:hr@bekoretech.com?subject=${encodeURIComponent(title)}`;

  return (
    <div css={styles.wrapper}>
      <div css={styles.header}>
        <h3 css={styles.title}>{title}</h3>
        <p css={styles.location}>{location}</p>

        {skills.length > 0 && (
          <div css={styles.skills}>
            {skills.map(s => (
              <span key={s.id}>{s.name || '—'}</span>
            ))}
          </div>
        )}
      </div>

      <TextSection title='Description' text={job.long_description} />
      <Section title='Responsibilities' text={job.responsibilities} />
      <Section title='Requirements' text={job.requirements} />
      <Section title='Nice to have' text={job.nice_to_have} />
      <Section title='What we offer' text={job.what_we_offer} />

      <a
        href='#'
        css={styles.apply}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          window.open(mailto, '_blank');
        }}
      >
        Apply
      </a>
    </div>
  );
}
